import {InputPhoneController} from './InputPhoneController';

Hop.defineModule('c-input-phone', (root, params) => {
    const $input = root.querySelector('input[type="tel"]');

    if (!$input) {
        throw new Error('Missing input[type="tel"] selector');
    }

    const ctrl = new InputPhoneController(root, $input, params);
    ctrl.initialize();

    return function destroy() {
        ctrl.destroy();
    };
});
